import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=04a1194d&"
import script from "./piechart.vue?vue&type=script&lang=js&"
export * from "./piechart.vue?vue&type=script&lang=js&"
import style0 from "./piechart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports